const Blogdata = [
  {
    id: 1,
    date: "12.04.2022'",
    title:
      "Aleksiej Byczkow to 25-letni rosyjski żołnierz, któremu zarzucono, że wykorzystał seksualnie niemowlę w Ukrainie.",
    cover: "./assets/blog/6.jfif",
    category:
      "//wiadomosci.onet.pl/swiat/wojna-rosja-ukraina-zelenski-wymienil-go-z-nazwiska-kim-jest-aleksiej-byczkow/qy40sc5",
  },
  {
    id: 2,
    date: "07.04.2022'",
    title:
      "Rosyjski żołnierz Jewgienij Kowalenko ukradł z Ukrainy przedmioty ważące w sumie 450 kg. W jego ręce wpadł m.in. stół, sprzęt audio, instrumenty muzyczne i namiot.",
    cover: "./assets/blog/7.jpg",
    category:
      "//www.o2.pl/informacje/zrabowal-w-ukrainie-i-wyslal-zonie-w-sumie-440-kg-6756623810525792a",
  },
  {
    id: 3,
    date: "07.04.2022'",
    title:
      "Michaił Tkacz miał mordować cywilów w Buczy. 'Zrozumcie, że jesteśmy na waszej ziemi i zabijamy was, a wy jesteście tylko śmierdzącymi, chodzącymi trupami' – napisał Michaił Tkacz.",
    cover: "./assets/blog/8.jpg",
    category: "//natemat.pl/405259,20-letni-michail-tkacz-mordowal-w-buczy",
  },
];

export default Blogdata;
